<template>
    <div class="disclaimer__wrapper">
        <div class="disclaimer__text">
            <p class="disclaimer__description" v-html="description"></p>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: 'Disclaimer',
    props: {
        description: {
            type: String,
            default: null,
        },
    },
};
</script>
